<template>
	<page>
		<module :title="id ? '编辑满赠活动' : '新建满赠活动'">
			<c-form ref="form">
				<c-form title="基础信息">
                    <!--默认与其他活动互斥-->
                    <c-form-item type="hidden" name="activity_mutex_flag" value="1"></c-form-item>
                    <!--默认【共享库存】-->
                    <c-form-item type="hidden" name="ind_activity_stock" value="0"></c-form-item>
                    <c-form-item type="input" label="活动名称" name="activity_name"  maxlength="20" required></c-form-item>
					<c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
					<c-form-item v-model="overlyingState" type="radio" label="赠品数是否叠加" name="gifts_kinds" :options="overlyingStateOption" required :inline-word="false"
                                 word="单次下单达到满赠门槛后，【不叠加】情况下无论数量是多少，赠品数量不变；【叠加】情况下，每达到一次满赠门槛，都可以获得一次赠品"></c-form-item>
<!--					<c-form-item type="radio" label="是否与其他活动互斥" v-model="activityMutexFlag" name="activity_mutex_flag" :options="activityMutexOption" required :inline-word="false"
                                 word="【互斥】则表示参加了该活动，则不再允许参加其他活动"></c-form-item>-->
					<c-form-item type="radio" label="叠加其他优惠" v-model="reducedMutexFlag" name="reduced_mutex_flag" :options="reducedMutexOption" required :inline-word="false"
                                 word="【允许】则表示参加了该活动的商品下单时，还可以在活动优惠的基础上，再次享受【优惠券】、【积分抵扣】等减免"></c-form-item>

                    <c-form-item type="input" label="活动标签" name="tags" maxlength="4" word="标签最多输入4个字符；该标签将显示在商品列表、SKU弹窗中"></c-form-item>
				</c-form>
				<c-form title="活动商品">
					<c-form-item>
						<m-operate>
							<c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
							<c-button color="gray" hollow @click="setLimit">批量设置满赠条件</c-button>
							<c-button color="gray" hollow @click="selectGift()">批量选择赠品</c-button>
						</m-operate>
						
						<c-table ref="productList" v-model="productList" height="500" :paging="false" border>
							<c-table-column
								type="selector"
							></c-table-column>
							
							<c-table-column
								label="商品信息"
								name="product_name"
								width="200"
							>
								<template v-slot="{data}">
									<div class="flex-center">
										<c-image :src="data.product_img_url" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                            {{data.product_name}}
                                        </p>
									</div>
								</template>
							</c-table-column>

							<c-table-column
								label="商品规格"
								name="product_sku_spec"
							></c-table-column>
							
							<c-table-column
								label="价格"
								name="product_price"
								width="80"
							>
								<template v-slot="{data}">￥{{data.product_price}}</template>
							</c-table-column>
							
							<c-table-column
								label="满赠条件"
								width="140"
							>
								<template v-slot="{data}">
									满<c-input v-model="data.count" width="50" type="number" :limit="[1,999]" style="margin: 0 5px;"></c-input>件可赠
								</template>
							</c-table-column>
							
							<c-table-column
								label="赠品"
							>
								<template v-slot="{data}">
                                  <a class="s-link" v-if="data.gift_list && data.gift_list.length > 0" @click="showGift(data)">已选赠品({{data.gift_list ? data.gift_list.length : 0}})</a>
                                  <a v-else style="color:red">未选赠品</a>
								</template>
							</c-table-column>

                            <c-table-column
                                    label="商品启/禁用"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="row">
                                    <c-switch :value="row.data.state == 2" text="启用,禁用" @change="changeProductState(row, arguments[0], arguments[1])"></c-switch>
                                </template>
                            </c-table-column>

							<c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="140"
							>
								<template v-slot="row">
                                    <c-table-button @click="selectGift(row)">选择赠品</c-table-button>
                                    <c-table-button @click="removeRow(row)">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
				</c-form>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(1)">确定提交</c-button>
			</template>
		</module>
        <product-selector ref="productSelector" sku multiple @resolve="productSelectHandle"></product-selector>
		<c-dialog ref="limitDialog" title="设置满赠条件" width="400" height="150" @resolve="setLimitHandle">
			<c-form>
				<c-form-item :label="false" required>
					满<c-input v-model="batchLimit" width="100" type="number" style="margin: 0 5px;"></c-input>件可赠
				</c-form-item>
			</c-form>
		</c-dialog>
        <c-dialog ref="giftDialog" title="赠品信息" width="800" height="450" @resolve="reloadGiftCount">
            <c-table ref="giftProductList" v-model="giftProductList" height="450" :value="giftProductList">
                <c-table-column
                    label="赠品信息"
                    name="product_name"
                    width="200"
                >
                  <template v-slot="{data}">
                    <div class="flex-center">
                      <c-image :src="data.product_img_url" size="46" preview></c-image>
                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                            {{data.product_name}}
                        </p>
                    </div>
                  </template>
                </c-table-column>

                <c-table-column
                    label="赠品规格"
                    name="product_sku_spec"
                ></c-table-column>

                <c-table-column
                    label="赠送数量"
                    name="count"
                    width="80"
                >
                  <template v-slot="{data}">
                    <c-input v-model="data.count" width="50" type="number" :limit="[1,999]" style="margin: 0 5px;"></c-input>件
                  </template>
                </c-table-column>

                <c-table-column
                    label="价格"
                    name="product_price"
                    width="80"
                >
                  <template v-slot="{data}">￥{{data.product_price}}</template>
                </c-table-column>

                <c-table-column
                    label="库存"
                    name="stock_count"
                    width="80"
                ></c-table-column>

                <c-table-column
                          type="button"
                          fixed="right"
                          label="操作"
                          width="80"
                  >
                      <template v-slot="row">
                          <c-table-button @click="deleteProductGift(row.data)">删除</c-table-button>
                      </template>
                </c-table-column>
            </c-table>
        </c-dialog>
  </page>
</template>

<script>
	import productSelector from '@/components/service/product_selector.vue'
	
	export default {
		name: 'reward_gift_edit',
		
		components: {
			productSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				overlyingState: 1,
				overlyingStateOption: [
                     {name: '叠加',value: 1},
                     {name: '不叠加',value: 2}
				],
                activityMutexFlag: 0,
                activityMutexOption: [
                     {name: '不互斥',value: 0},
                     {name: '互斥',value: 1}
				],
                reducedMutexFlag: 0,
                reducedMutexOption: [
                    {name: '不叠加',value: 0},
                    {name: '叠加',value: 1}
				],
                productList: [],
                giftProductList: [],
                batchLimit: '',
                main_product_sku: 0      //主商品SKU信息
			}
		},
		watch: {
			id() {
				this.getActivityDetail();
			},
			
			commodityRange(val) {
				if (val == 2) {
					this.$refs.productList.resize();
				}
			}
		},
		
		mounted() {
			this.id && this.getActivityDetail();
		},
		
		methods: {
			getActivityDetail() {
				this.request({
					url: '/activityGifts/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						
						this.productList = data.product_list;
					}
				});
			},

			productSelectHandle(list) {
                if(list){
                      //默认赠品1件
                      list.forEach(gift => {
                        gift.count = 1;
                      });
                }
                if (this._gift) {
                    this._gift.forEach(row => {
                        row.update({
                            gift_list: list
                        });
                    });
                    delete this._gift;
                } else {
					list = list.filter(item => {
						return !this.productList.find(row => {
							return row.product_sku == item.product_sku;
						});
					});
					this.productList = this.productList.concat(list);
				}
			},

			selectGift(item) {
				this._gift = item ? [item] : this.$refs.productList.getRow('selected');
				if (!this._gift.length) {
					this.$message({
						text: '请选择商品'
					});
					delete this._gift;
					return;
				}
				this.$refs.productSelector.open();
			},

			setLimit() {
				this._limit = this.$refs.productList.getRow('selected');
				if (!this._limit.length) {
					this.$message({
						text: '请选择商品'
					});
					delete this._limit;
					return;
				}
				
				this.batchLimit = '';
				this.$refs.limitDialog.open();
			},

			setLimitHandle(stop) {
				if (!this.batchLimit) {
					stop();
					this.$message({
						text: '请填写满赠条件'
					});
					return;
				}
				this._limit.forEach(row => {
					row.update({
						count: this.batchLimit
					});
				});
			},

			submit(state) {
				this.$refs.form.submit({
					url: this.id ? '/activityGifts/edit' : '/activityGifts/add',
					rule: {
						activity_name: '请填写活动名称',
						begin_date: '请选择活动时间',
						// tags: '请填写活动标签',
						product_list: [{
							type: 'function',
							fun: () => {
								return this.productList.length;
							},
							word: '请选择活动商品'
						}],
						product_config: [{
							type: 'function',
							fun: () => {
								return !this.productList.find(item => {
									return !item.count || !item.gift_list || !item.gift_list.length;
								});
							},
							word: '请设置商品满减条件及赠品'
						}]
					},
					
					dataFormatter: data => {
						this.id && (data.id = this.id);
						
						data.product_list = Array.from(this.productList, item => {
							return {
								product_id: item.product_id,
								product_sku: item.product_sku,
								count: item.count,
								state: item.state,
                                activity_discount: 10,//默认不打折
								gift_list: Array.from(item.gift_list, gift => {
									return {
                                      product_id: gift.product_id,
                                      product_sku: gift.product_sku,
                                      count: gift.count
									}
								})
							}
						});
						
						return data;
					},
					
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('rewardGiftList.update');
						this.redirectTo('/reward_gift');
					}
				})
			},

            showGift(data){
                this.main_product_sku = data.product_sku;
                if (data && data.gift_list && data.gift_list.length > 0){
                    this.giftProductList = data.gift_list.map(item => {
                        item.main_product_sku = this.main_product_sku;
                        return item;
                    });
                    this.$refs.giftDialog.open();
                }
              },

            //删除参加活动的商品赠品
            deleteProductGift(rowData){
                const index = this.giftProductList.indexOf(rowData);
                this.giftProductList.splice(index, 1);
            },

            reloadGiftCount() {
                var current_product = null;
                var temp_gift_list = [];
                // 获取所有行数据
                var giftList = this.$refs.giftProductList.getRow();
                giftList.forEach(row => {
                  temp_gift_list.push(row.data);
                });
                this.productList.forEach(product => {
                  if (this.main_product_sku  == product.product_sku){
                      current_product = product;
                  }
                });
                if (current_product){
                    current_product.gift_list = temp_gift_list;
                }
           },
            /**
             * 删除行
             */
            removeRow(row) {
                this.$confirm({
                    text: '是否确定将商品【'+row.data.product_name+'】从当前活动中删除（提交保存后生效）？',
                    buttonName: '确定删除',
                    cancelButton: true,
                    resolve: () => {
                        row.remove();
                    }
                });
            },
            /**
             * 活动启禁用
             * @param state true = 启用(2)  false=禁用(1)
             */
            changeProductState(row,state, stop) {
                row.data.state = state?2:1;
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.limit {
		.item {
			margin-right: 16px;
			
			label {
				margin-right: 8px;
			}
		}
	}
</style>